import React, { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowDown, faSliders, faRefresh } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select'
import axios from 'axios';
import { Tooltip } from 'flowbite';
import ColorPicker from 'react-best-gradient-color-picker'
import { toPng  } from 'html-to-image';
import Spiner from '../components/Spiner';
import commonFunc from '../common';


const BE_API_URL = process.env.REACT_APP_BACKEND_API_URL;
const bgColorReady = commonFunc.bgColorReady

const modeOptions =[
  { label: 'Hide everything', value: 0 },
  { label: 'Show retweet/like counts', value: 1 },
  { label: 'Show retweet/like counts & timestamp', value: 2 },
  { label: 'Show everything', value: 3 },
  { label: 'Show timestamp', value: 4 }
]

const nightModeOptions = [
  { label: 'Light', value: 0 },
  { label: 'Dark', value: 1 },
  { label: 'Black', value: 2 },
]

const defaultSettings = {
  imageWidth: 700,
  imageHeight: 700,
  tweetWidth: (700 * 0.7).toFixed(2),
  tweetHeight: null,
  paddingY: 20,
  paddingX: 20,
}

const TextToSocialImage = () => {
  const codeRef = useRef();
  const [url, setUrl] = useState('');
  const [linkChangesCount, setLinkChangesCount] = useState(0)
  const [modeSelection, setModeSelection] = useState(modeOptions[0])
  const [nightModeSelection, setNightModeSelection] = useState(nightModeOptions[0])
  const [color, setColor] = useState('linear-gradient(135deg, rgb(54, 209, 220) 0%, rgb(91, 134, 229) 100%)');
  const [imageSrc, setImageSrc] = useState(null)
  const [imageSettings, setImageSettings] = useState(defaultSettings)
  const [colorTab, setColorTab] = useState(0)
  const [selectBgColorReady, setSelectBgColorReady] = useState(null)
  const [hasBackground, setHasBackground] = useState(true)
  const [aspectRatio, setAspectRatio] = useState('1:1');

  const handleHasBackgroundChange = () => {
    const newValue = !hasBackground
    setHasBackground(newValue)
    const height = calculateHeight(aspectRatio)
    if (newValue) {
      const imageWidth = imageSettings.imageWidth * 0.5
      setImageSettings({ ...imageSettings, imageWidth: imageWidth, imageHeight: height })
    } else {
      setImageSettings({ ...imageSettings, imageHeight: height })
    }
  }

  const calculateHeight = (newAspectRatio) => {
    const [widthRatio, heightRatio] = newAspectRatio.split(':').map(Number);
    const height = (imageSettings.imageWidth * heightRatio) / widthRatio;
    return height
  }

  const handleCaptureImage = async () => {
    setLinkChangesCount(1)
    setImageSrc('')
    try {
      axios.post(`${BE_API_URL}/api/tweetCapture`, {
        url, mode: modeSelection.value, nightMode: nightModeSelection.value
      })
      .then(function (response) {
        if (response.status) {
          setLinkChangesCount(0)
          const imageUrl = `${BE_API_URL}/images/${response.data.filenames[0]}`
          setImageSrc(imageUrl)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    } catch (err) {
    }
  };

  const options = {
    placement: 'bottom',
    triggerType: 'none',
    onHide: () => {
        console.log('tooltip is shown');
    },
    onShow: () => {
        console.log('tooltip is hidden');
    },
    onToggle: () => {
        console.log('tooltip is toggled');
    },
  }; 

  const handleShowTooltipColor = () => {
    const instanceOptions = {
      id: 'popover-user-profile',
      override: true
    };
    const $targetElColor = document.getElementById('popover-user-profile');
    const $triggerElColor = document.getElementById('color-tooltip');
    const tooltipColor = new Tooltip($targetElColor, $triggerElColor, options, instanceOptions);
    tooltipColor.init()
    tooltipColor.show()
  }

  const handleShowTooltipSettings = () => {
    const $targetElSettings = document.getElementById('popover-settings')
    const $triggerElSettings = document.getElementById('popover-settings-btn');
    const instanceOptionsSetting = {
      id: 'popover-settings',
      override: true
    };
    const tooltipSetting = new Tooltip($targetElSettings, $triggerElSettings, options, instanceOptionsSetting);
    tooltipSetting.init()
    tooltipSetting.show()
  }

  const handleSelectBgColorReadyChange = (option) => {
    setSelectBgColorReady(option)
    setColor(option.value)
  }

  const handleResetToDefault = () => {
    setImageSettings(defaultSettings)
  }

  const handleImageSettingsChange = (e) => {
    let newValue = e.target.value
    if (e.target.name === 'tweetWidth') {
      setImageSettings({
        ...imageSettings,
        tweetHeight: null,
        tweetWidth: newValue
      })
    } else {
      setImageSettings({
        ...imageSettings,
        [e.target.name]: newValue,
      })
    }
    setAspectRatio(null)
  }

  const handleChangeAspectRatio = (e) => {
    const newValue = e.target.value
    setAspectRatio(newValue)
    const height = calculateHeight(newValue)
    setImageSettings({ ...imageSettings, imageHeight: height, tweetHeight: height * 0.8, tweetWidth: null })
  }

  const downloadAsImage = async () => {
    if (codeRef.current === null) {
      return;
    }
    toPng(codeRef.current, { cacheBust: true })
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = `tweet-to-image.png`
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.error('Oops, something went wrong!', err);
      });
  };

  return (
    <div className="grid grid-cols-1 xl:grid-cols-1 xl:gap-4">
      <div className="col-span-2 xl:col-auto">
        <div className="p-4 min-h-screen space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          {/* <div className="px-4 py-2 pt-20 text-gray-400 rounded dark:border-gray-600 flex justify-center">
            <div className="relative w-2/4">
              <Select value={modeSelection} onChange={(option) => setModeSelection(option)} className='inline-block w-1/2' options={modeOptions} />
              <Select value={nightModeSelection} onChange={(option) => setNightModeSelection(option)} className='inline-block w-1/2' options={nightModeOptions} />
            </div>
          </div> */}
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600 flex justify-center">
            <div className="relative w-2/4">
              <input
                type="url"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                className="block p-4 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-lg rounded-s-gray-100 rounded-s-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500"
                required={true}
                placeholder='Enter X (Twitter) URL'
              />
              <button
                type="button"
                onClick={handleCaptureImage}
                disabled={!url}
                className="absolute top-0 end-0 px-4 p-2.5 h-full text-sm font-medium text-white bg-blue-700 rounded-e-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Submit
              </button>
            </div>
          </div>
          <div className="px-4 py-2 text-gray-400 dark:border-gray-600 flex justify-center">
            {imageSrc && (
              <div className="relative w-2/4">
                <button
                  onClick={handleShowTooltipColor}
                  id="color-tooltip"
                  type="button"
                  className="text-gray-600 focus:ring-4 border border-gray-200 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-4 text-center dark:focus:ring-blue-800"
                  style={{background: color}}
                >
                  <span style={{color: 'transparent'}} width={40}>C</span>
                </button>
                <div
                  data-popover=""
                  id="popover-user-profile"
                  role="tooltip"
                  className="absolute z-10 invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-600"
                >
                  <div className="p-3">
                    <div className="mb-4 border-b border-gray-200 dark:border-gray-700">
                      <ul
                        className="flex flex-wrap -mb-px text-sm font-medium text-center"
                      >
                        <li className="me-2" role="presentation">
                          <button
                            className={colorTab === 0 ? `inline-block p-4 rounded-t-lg border-blue-600 border-b-2` : 'inline-block p-4 rounded-t-lg border-b-2'}
                            type="button"
                            onClick={() => setColorTab(0)}
                          >
                            Ready-to-use
                          </button>
                        </li>
                        <li className="me-2" role="presentation">
                          <button
                            className={colorTab === 1 ? `inline-block p-4 rounded-t-lg border-blue-600 border-b-2` : 'inline-block p-4 rounded-t-lg border-b-2'}
                            type="button"
                            onClick={() => setColorTab(1)}
                          >
                            Customize
                          </button>
                        </li>
                      </ul>
                      <div className='mt-4'>
                        { colorTab === 0 && <Select className='inline-block  w-full' value={selectBgColorReady} options={bgColorReady} onChange={handleSelectBgColorReadyChange} /> }
                        { colorTab === 1 && <ColorPicker value={color} onChange={setColor} /> }
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  onClick={handleShowTooltipSettings}
                  id="popover-settings-btn"
                  type="button"
                  className='text-blue-700 ml-4 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-4 text-center me-2 mb-2 dark:border-blue-500 dark:text-gray-200 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800'
                >
                  <FontAwesomeIcon icon={faSliders}/>
                  &nbsp;Settings
                </button>
                <div
                    data-popover=""
                    id="popover-settings"
                    role="tooltip"
                    className="absolute z-10 invisible inline-block w-84 text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-600"
                  >
                    <div className="p-3">
                      <form className="max-w-sm mx-auto">
                        <div class="flex items-center ps-4 mb-2  dark:border-gray-700">
                          <input
                            checked={hasBackground}
                            onChange={handleHasBackgroundChange}
                            id="checked-checkbox-2" type="checkbox"
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                          <label for="checked-checkbox-2" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Background</label>
                        </div>
                        { hasBackground && (
                          <>
                            <div class="flex items-center ps-4  dark:border-gray-700">
                              <label
                                htmlFor="number-input"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Width ({imageSettings.imageWidth})
                              </label>
                              <input min={200} max={2000} onChange={handleImageSettingsChange} name="imageWidth" type="range" value={imageSettings.imageWidth} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                            </div>
                            <div class="flex items-center ps-4  dark:border-gray-700">
                              <label
                                htmlFor="number-input"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Height ({imageSettings.imageHeight})
                              </label>
                              <input min={200} max={2000} onChange={handleImageSettingsChange} name="imageHeight" type="range" value={imageSettings.imageHeight} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                            </div>
                            <div class="flex items-center ps-4  dark:border-gray-700">
                              <label
                                htmlFor="number-input"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Padding Top/Bottom ({imageSettings.paddingY})
                              </label>
                              <input min={0} max={100} onChange={handleImageSettingsChange} name="paddingY" type="range" value={imageSettings.paddingY} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                            </div>
                          </>
                        ) }
                        <div class="flex items-center ps-4  dark:border-gray-700">
                          <label
                            htmlFor="number-input"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                          >
                            Tweet Width ({imageSettings.tweetWidth})
                          </label>
                          <input min={100} max={imageSettings.imageWidth} onChange={handleImageSettingsChange} name="tweetWidth" type="range" value={imageSettings.tweetWidth} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                        </div>
                        <div class="flex items-center ps-4  dark:border-gray-700">
                          <label
                            htmlFor="number-input"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                          >
                            Tweet Height ({imageSettings.tweetHeight ? imageSettings.tweetHeight : 'auto'})
                          </label>
                          <input min={100} max={imageSettings.imageHeight ? imageSettings.imageHeight : 1000 } onChange={handleImageSettingsChange} name="tweetHeight" type="range" value={imageSettings.tweetHeight} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                        </div>
                        <div class="flex items-center ps-4  dark:border-gray-700">
                          <button
                            type="button"
                            onClick={handleResetToDefault}
                            className="text-white bg-gray-500 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
                          >
                            <FontAwesomeIcon icon={faRefresh}/>
                            &nbsp;Reset to default
                          </button>
                        </div>
                      </form> 
                    </div>
                </div>
                <select
                  id="aspect-ratio-select"
                  value={aspectRatio}
                  onChange={(e) => handleChangeAspectRatio(e)}
                  placeholder='Custom aspect ratio'
                  className='bg-gray-50 mr-2 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                >
                  <option value="9:16">9:16 (Portrait)</option>
                  <option value="16:9">16:9 (Landscape)</option>
                  <option value="1:1">1:1 (Square)</option>
                </select>
                <button
                  type="button"
                  onClick={() => downloadAsImage()}
                  className="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-[#2557D6]/50 focus:outline-none font-medium rounded-lg text-sm px-5 py-4 text-center inline-flex items-center dark:focus:ring-[#2557D6]/50 me-2 mb-2"
                >
                  <FontAwesomeIcon icon={faCloudArrowDown}/>
                  &nbsp; Download
                </button>
              </div>
            )}
          </div>
          <div className="px-4 py-2 text-gray-400 dark:border-gray-600 flex justify-center">
            <Spiner visible={!imageSrc && linkChangesCount > 0} />
            { imageSrc && (
              <div
                ref={codeRef}
                className='items-center border rounded-lg justify-center flex'
                style={{
                  background: hasBackground ? color : 'transparent',
                  width: hasBackground ? `${imageSettings.imageWidth}px` : 'auto',
                  height: hasBackground ? `${imageSettings.imageHeight}px` : 'auto',
                  paddingTop: hasBackground ? `${imageSettings.paddingY}px` : 0,
                  paddingBottom: hasBackground ? `${imageSettings.paddingY}px` : 0,
                  paddingLeft: hasBackground ? `${imageSettings.paddingX}px` : 0,
                  paddingRight: hasBackground ? `${imageSettings.paddingX}px` : 0
                }}
              >
                <img
                  src={imageSrc}
                  style={{
                    width: imageSettings.tweetWidth ? `${imageSettings.tweetWidth}px` : 'auto',
                    height: imageSettings.tweetHeight ? `${imageSettings.tweetHeight}px` : 'auto',
                  }}
                  className='rounded-xl'
                />
              </div>
            ) }
          </div>
        </div>
      </div>
    </div>
  )
}

export default TextToSocialImage;
